import cn from "classnames";
import type {AppTextButtonProps} from "./TextButton.types";
import styles from "./TextButton.module.scss";

export const getClassNames = (props: AppTextButtonProps) => {
  const {color, className} = props;

  return cn(
    styles["type-text"],
    color && styles[`color-${color}`],
    className,
  );
};